<template>
  <div class="list">
    <ToolTitle :title="company.name" :menu="true" :menuby="'company'" />
    <div class="list__wrapper">
      <div class="list__input">
        <FormSearch :placeholder="'Form ara...'" v-model.trim="search" />
      </div>
      <div v-if="!nodata" class="list__items -nohover">
        <div class="list__items__item -title -first">Form adı</div>
        <div class="list__items__item -title">Marka</div>
        <!-- <div class="list__items__item -title">Oluşturan</div>
        <div class="list__items__item -title">Son düzenleyen</div>-->
        <div class="list__items__item -title">Url</div>
        <div class="list__items__item -title">Doldurulma</div>
        <div class="list__items__item -title -last">Durum</div>
      </div>
      <ToolLoading v-if="!isloaded" />
      <div class="list__items" v-for="(item, index) in filteredList" :key="index">
        <div class="list__items__item -link -first" @click="open(item)">{{item.name}}</div>
        <div class="list__items__item">{{item.company.name}}</div>
        <!-- <div
          class="list__items__item -info"
          :title="item.created.date"
        >{{item.created.by | filtername}}</div>
        <div
          class="list__items__item -info"
          :title="item.updated.date"
        >{{item.updated.by | filtername}}</div>-->
        <div class="list__items__item -copy" v-copy="`${site}/${item.company.path}/${item.path}`"></div>
        <div class="list__items__item">{{item.count}}</div>
        <div class="list__items__item -last">
          <FormCheckbox v-model="item.status" @action="update(item)" />
        </div>
      </div>
      <div class="list__nodata" v-if="nodata && isloaded">
        <div class="list__nodata__image">
          <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 130 130">
            <defs>
              <linearGradient id="prefix__a" x1="75.103%" x2="33.8%" y1="100%" y2="0%">
                <stop offset="0%" stop-color="#D3EAF0" />
                <stop offset="100%" stop-color="#E6EDF0" />
              </linearGradient>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <circle cx="65" cy="65" r="65" fill="url(#prefix__a)" />
              <path
                fill="#FFF"
                d="M65 34c7.467 0 14.517 2.623 20.119 7.438 1.072-1.992 2.262-3.814 2.828-4.655.702-1.044 2.403-1.044 3.106 0C92.213 38.506 96 44.358 96 47.34c0 2.157-1.007 4.079-2.564 5.297l-.027-.064c1.718 3.91 2.591 8.09 2.591 12.43C96 82.095 82.094 96 65 96S34 82.094 34 65s13.906-31 31-31zm0 3.875c-14.958 0-27.125 12.167-27.125 27.125S50.042 92.125 65 92.125c14.957 0 27.125-12.167 27.125-27.125 0-3.797-.762-7.456-2.263-10.87l-.054-.137c-.102.005-.205.007-.308.007-3.583 0-6.5-2.989-6.5-6.661 0-.627.168-1.381.443-2.197-5.025-4.697-11.528-7.267-18.443-7.267zm15.432 42.557c.757.816.757 2.14 0 2.955-.377.41-.873.613-1.37.613-.496 0-.992-.203-1.37-.613-6.445-6.946-16.936-6.946-23.382 0-.757.816-1.985.816-2.742 0-.757-.816-.757-2.139 0-2.955 7.955-8.576 20.909-8.576 28.864 0zM58.05 54c1.077 0 1.95.827 1.95 1.846C60 59.238 57.085 62 53.5 62S47 59.238 47 55.846c0-1.019.873-1.846 1.95-1.846 1.076 0 1.95.827 1.95 1.846 0 1.356 1.165 2.462 2.6 2.462s2.6-1.106 2.6-2.462c0-1.019.874-1.846 1.95-1.846zm23 0c1.076 0 1.95.827 1.95 1.846C83 59.238 80.085 62 76.5 62S70 59.238 70 55.846c0-1.019.874-1.846 1.95-1.846s1.95.827 1.95 1.846c0 1.356 1.165 2.462 2.6 2.462s2.6-1.106 2.6-2.462c0-1.019.874-1.846 1.95-1.846zm8.45-12.567c-.727 1.218-1.394 2.44-1.886 3.476-.048.344-.19.677-.425.96-.263.64-.414 1.153-.414 1.467 0 1.542 1.22 2.793 2.725 2.793 1.505 0 2.725-1.253 2.725-2.793 0-.895-1.235-3.41-2.725-5.903z"
              />
            </g>
          </svg>
        </div>
        <div class="list__nodata__message">Üzgünüz, aradığınız kriterlere uygun bir form bulunamadı.</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import { global } from "@/global";
import { copy } from "@/directives/";
import * as Helpers from "@/helpers/";

export default {
  data() {
    return {
      company: this.$store.getters.getActiveCompany,
      forms: [],
      isloaded: false,
      site: `${global["API"]}/${global["FORMPATH"]}`,
      search: ""
    };
  },
  directives: { copy },
  created() {
    this.init();
  },
  computed: {
    filteredList() {
      return this.forms.filter(item => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    nodata() {
      return this.filteredList.length > 0 ? false : true;
    }
  },
  filters: {
    filtername(name) {
      return name.split("@")[0];
    }
  },
  methods: {
    init: async function() {
      let vm = this;

      await API.getForms(vm.$route.params.company).then(
        response => (vm.forms = response.result)
      );

      vm.isloaded = true;
    },
    open: function(form) {
      this.$router.push({
        name: "form",
        params: { form: form.path, company: this.$route.params.company }
      });
    },
    update: async function(form) {
      form.updated = {
        by: this.$store.getters.getUser,
        date: await Helpers.currentDateTime()
      };

      await API.updateForm(form);
    }
  }
};
</script>